import React, { useState, cloneElement } from 'react';
import { tabs } from './author-launchpad/constants';
import { RoadmapTab } from './author-launchpad/RoadmapTab';
import { ToolsTab } from './author-launchpad/ToolsTab';
import { VendorsTab } from './author-launchpad/VendorsTab';
import { ChecklistTab } from './author-launchpad/ChecklistTab';
import { useDarkMode } from '../../context/DarkModeContext';
import { useUserRole } from '../../context/UserRoleContext';
import { TroveLayout } from '../../components/Trove/TroveLayout';
const AuthorLaunchpad = () => {
  const {
    darkMode
  } = useDarkMode();
  const {
    isReader
  } = useUserRole();
  const [activeTab, setActiveTab] = useState('roadmap');
  // Role-based colors (Vendor focused, but using system for consistency)
  const activeTabClass = isReader ? 'text-indigo-600 border-indigo-600' : 'text-purple-600 border-purple-600';
  const activeIconClass = isReader ? 'text-indigo-600' : 'text-purple-600';
  const hoverTextClass = isReader ? 'hover:text-indigo-600' : 'hover:text-purple-600';
  const renderTabContent = () => {
    switch (activeTab) {
      case 'roadmap':
        return <RoadmapTab data-id="element-16345" data-mp="supg48pe6ga2" />;
      case 'tools':
        return <ToolsTab data-id="element-16346" data-mp="sxldnvxbv2xz" />;
      case 'vendors':
        return <VendorsTab data-id="element-16347" data-mp="xvv9m8qvm7kn" />;
      case 'checklist':
        return <ChecklistTab data-id="element-16348" data-mp="12twqcn0txusy" />;
      default:
        return <div data-id="element-16349" data-mp="12svbs8kluq6h">Select a tab to view content</div>;
    }
  };
  return <TroveLayout data-id="element-16350" data-mp="56fw9cbqo2lk">
      {/* Hero Section */}
      <div className="mb-8" data-id="element-16351" data-mp="57r0ted0dedq">
        <h1 className={`text-3xl sm:text-4xl font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-16352" data-mp="54bj03ry9r8m">
          Author Launchpad
        </h1>
        <p className={`text-base ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-16353" data-mp="f3kckviwl3ug">
          Execution hub for self-publishing authors. Tools, templates, and
          vendors to get your book to market.
        </p>
      </div>

      {/* Tabs Navigation */}
      <div className={`sticky top-0 ${darkMode ? 'bg-gray-900 border-gray-800' : 'bg-gray-50 border-gray-200'} border-b z-30 mb-8`} data-id="element-16354" data-mp="3njdtvcl26jck">
        <div className="overflow-x-auto scrollbar-none" data-id="element-16355" data-mp="3fhd7v8quuts7">
          <div className="flex min-w-max" data-id="element-16356" data-mp="3bgtb46a71s6l">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center px-6 py-4 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab.id ? activeTabClass + ' border-b-2' : `${darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600'} ${hoverTextClass} border-b-2 border-transparent`}`} data-id="element-16357" data-mp="3p9sljtv4cw7a">
                {cloneElement(tab.icon as React.ReactElement, {
              className: `h-5 w-5 ${activeTab === tab.id ? activeIconClass : 'text-gray-400'} mr-2`
            })}
                {tab.label}
              </button>)}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div data-id="element-16358" data-mp="gso37kqwkn1r">{renderTabContent()}</div>
    </TroveLayout>;
};
export default AuthorLaunchpad;